
import { IEntity } from "@interfaces/entity";
import { PricingDto } from "./pricingDto";
import { Address } from "../models/address";

export class UserDto implements IEntity {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  gender: string;
  company: string;
  rfidCardsString: string;
  address: Address;
  postcode: string;
  city: string;
  street: string;
  houseNumber: string;
  pricing?: PricingDto;
  pricingId?: number;
  allowedChargingStationsString: string;
  selectedCustomerId: number;
  subscriptionTypeId: number;
  isPasswordSet?: boolean;

  entityName = "UserDto";

  getPrimaryKey() {
    return this.id;
  }

  updateValues(formValue: Partial<UserDto>) {
    Object.assign(this, formValue);
  }
}
